import routes from "./routes";
import {
  createRouter,
  createWebHistory,
  type NavigationFailure,
  type RouteLocationNormalized,
  type RouteLocationRaw,
} from "vue-router";
import { useUser } from "@/store/user";
// import { keycloak } from "@/utilities/keycloak";
// import { LocalStorage } from "@/storage";
import { intersection } from "lodash";
// import { CookieStorage } from "@/storage/index";

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(
  async (to: RouteLocationNormalized): Promise<void | RouteLocationRaw | NavigationFailure> => {
    const userStore = useUser();

    if (userStore.isSuspended) {
      if (to.meta.authRequired) {
        return {
          name: "suspended-user",
        };
        return;
      }
    }

    if( userStore.isLoggedIn ){
      if (userStore.isPending && to.name !== "wrong-role") {
        if( userStore.getSavedRoleName != '' ){
          const roleDetail = userStore.roles.find(
            (r) => r.roleName.toLowerCase() == userStore.getSavedRoleName
          );
          if (roleDetail && window.location.hostname != 'localhost' ) {
            if (window.location.pathname != "/account/" + roleDetail.page) {
              window.location.href = "/account/" + roleDetail.page;
              return;
            }
          }
        }else if(userStore.nextIncompleteRole){
          // userStore.getSavedRoleName is not setted
          const roleDetail = userStore.nextIncompleteRole;
          if (roleDetail && window.location.hostname != 'localhost') {
            if (window.location.pathname != "/account/" + roleDetail.page) {
              window.location.href = "/account/" + roleDetail.page;
              return;
            }
          }
        }

        return {
          name: "wrong-role",
        };
      }
    }

    // Redirect the user to its previous location if any
    // or to home on routes that are meant for guests only
    if (to.meta.guestOnly) {
      if (userStore.isLoggedIn) {
        console.log("tried to access a guest only route while logged in");
        if (to.query.redirect) {
          console.log("redirecting as specified");
          const { name, ...rest } = to.query;
          return {
            name: name?.toString(),
            query: rest,
          };
        } else {
          console.log("redirecting to home");
          return {
            name: "home",
          };
        }
      }
    }

    if (to.meta.authRequired) {
      if (!userStore.isLoggedIn) {
        return { name: "welcome" };
      } else {
        if (userStore.missingAgreements.length > 0 && to.name !== "additional-agreement") {
          return {
            name: "additional-agreement",
          };
        }
        // console.log('userStore.hasAccessToApplication', userStore.hasAccessToApplication)
        if (!userStore.hasAccessToApplication && to.name !== "wrong-role") {
          return {
            name: "wrong-role",
          };
        }        
      }
      /**
       * When routes are bound by role ensure the user has at least one of the allowed roles
       */
      if (to.meta.privilege) {
        const privilege: { resource: string; attribute: string } | null =
          to.meta?.privilege ?? null;
        if (privilege && userStore.isHidden(privilege.attribute, privilege.resource)) {
          console.log(
            `User tried to access a route`,
            to.path,
            ` which he is not authorized to enter,`,
            ` redirecting.`
          );
          return router.push({ name: "home" });
        }
      }
      if (to.meta.roles) {
        const matching = intersection(
          userStore.roles.map((r) => r.roleName),
          to.meta.roles
        );
        if (!matching.length) {
          console.log(
            `User tried to access a route`,
            to.path,
            ` which he is not authorized to enter,`,
            ` redirecting.`
          );
          return router.push({ name: "home" });
        }
      }
    }
  }
);

export default router;
